import React from "react"
import { createTheme, ThemeProvider, alpha } from "@mui/material/styles"

export default class ThemeProviderWrapper extends React.Component {

  render() {

    const redBase = '#ee534f';

    const theme = createTheme({
      typography: {
        fontFamily: ["Lato", "Open Sans"].join(","),
        color: "black",
      },
      palette: {
        primary: {
          light: "#aaa0ff",
          main: "#7471f7",
          dark: "#3946c3",
          contrastText: "#fff",
        },
        secondary: {
          light: "#9be7ff",
          main: "#64b5f6",
          dark: "#2286c3",
          contrastText: "#fff",
        },
        warning: {
          light: "#ffdd71",
          main: "#ffab40",
          dark: "#c77c02",
          contrastText: "#fff",
        },
        playing: {
          light: "#4db6ac",
          main: "#4db6ac",
          dark: "#4db6ac",
          contrastText: "white",
        },
        alert: {
          light: alpha(redBase, 0.5),
          main: redBase,
          dark: redBase,
          contrastText: "white",
        }
      },
    })

    return (
      <ThemeProvider theme={theme}>
        {this.props.children}
      </ThemeProvider>
    )
  }
}
